import { render, staticRenderFns } from "./ServiceCode.vue?vue&type=template&id=e2638ca2"
import script from "./ServiceCode.vue?vue&type=script&lang=js"
export * from "./ServiceCode.vue?vue&type=script&lang=js"
import style0 from "./ServiceCode.vue?vue&type=style&index=0&id=e2638ca2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports